import 'css-chunk:src/components/page-alert/page-alert-component.module.scss';export default {
  "page-alert-component": "page-alert-component_page-alert-component__FMRVn",
  "page-alert-side": "page-alert-component_page-alert-side__QdkWK",
  "yellow": "page-alert-component_yellow__qQ-us",
  "page-alert-side-slant": "page-alert-component_page-alert-side-slant__crTzX",
  "teal": "page-alert-component_teal__u3U8o",
  "pink": "page-alert-component_pink__IBJQy",
  "green": "page-alert-component_green__clj8-",
  "purple": "page-alert-component_purple__0UUts",
  "stacked": "page-alert-component_stacked__N5Yi0",
  "page-alert-content": "page-alert-component_page-alert-content__AUtt9",
  "close": "page-alert-component_close__-GnGY",
  "non-stacked": "page-alert-component_non-stacked__00ULA",
  "btn": "page-alert-component_btn__jKVmP",
  "page-alert-side-wrapper": "page-alert-component_page-alert-side-wrapper__oSGnC",
  "icon": "page-alert-component_icon__Y-clm"
};